import { SubscriptionStatus, Maybe } from '../../../__generated__/globalTypes'

import {
  SubscriptionFeatures,
  isSubscriptionFeatures,
} from './SubscriptionFeatures'

import {
  SubscriptionMetadata,
  isSubscriptionMetadata,
} from './SubscriptionMetadata'

import stripeSubscriptionRawString from '../StripeSubscription.graphql'

export const stripeSubscriptionString = stripeSubscriptionRawString

export type StripeSubscription = {
  id: string
  name: string
  status: SubscriptionStatus
  startDate: string
  currentPeriodEnd: string
  interval: string
  intervalCount: number
  price: number
  isSetToCancel: boolean
  sku: string
  features: Maybe<SubscriptionFeatures>
  metadata: Maybe<SubscriptionMetadata>
}

export const isStripeSubscription = (
  fragment: any,
): fragment is StripeSubscription =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.name === 'string' &&
  (fragment.status === 'ACTIVE' ||
    fragment.status === 'CANCELED' ||
    fragment.status === 'PAST_DUE' ||
    fragment.status === 'TRIALING' ||
    fragment.status === 'UNPAID') &&
  typeof fragment.startDate === 'string' &&
  typeof fragment.currentPeriodEnd === 'string' &&
  typeof fragment.interval === 'string' &&
  typeof fragment.intervalCount === 'number' &&
  typeof fragment.price === 'number' &&
  typeof fragment.isSetToCancel === 'boolean' &&
  typeof fragment.sku === 'string' &&
  (fragment.features === null ||
    (isSubscriptionFeatures(fragment.features) as boolean)) &&
  (fragment.metadata === null ||
    (isSubscriptionMetadata(fragment.metadata) as boolean))
